import { Button, Dialog, DialogContent, DialogTitle, IconButton, DialogActions, TextField, Grid, FormHelperText } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import { getCompanyId, getToken, getUser } from "../../Utils/Common";
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from "axios";


const CompanyEnvisionDialog = ({ open, handleClose, onClose, action, data, setReload }) => {
    const [companyInfo, setCompanyInfo] = useState({});
    const [valid, setValid] = useState({});
    const [isReadOnly, setReadOnly] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        // getEnVisionCompanyData(data.companyId);
        if (action === 'create') {
            setReadOnly(false);
        } else if (action === 'view') {
            setReadOnly(true);
        } else if (action === 'edit') {
            setReadOnly(false);
        }
    }, [action]);

    useEffect(() => {
        let companyObj = {
            "companyId": data.companyId ?? "",
            "companyName": data.name ?? data.companyName ?? "",
            "enVisionWSURL": data.enVisionServerUrl ?? data.enVisionWSURL ?? "",
            "webServiceToken": data.webServiceToken ?? "",
            "enVisionChunkerTempPath": data.enVisionChunkerTempPath ?? "",
            "enVisionIntegrationUserId": data.enVisionIntegrationUserId ?? 0,
            "defaultDocumentType": data.defaultDocumentType ?? "",
            "encryptedUserName": data.encryptedUserName ?? "",
            "encryptedUserPassword": data.encryptedUserPassword ?? "",
            "useChunkerPath": data.useChunkerPath
        }
        setCompanyInfo(companyObj)
        setValid({})
    }, [data]);

    const checkValidation = () => {
        let valid = {}

        if (!("companyName" in companyInfo) || companyInfo.companyName.length === 0) {
            valid['companyName'] = false;
        } else {
            valid['companyName'] = true;
        }

        if (action === 'edit') {
            if (!("enVisionWSURL" in companyInfo) || companyInfo.enVisionWSURL.length === 0) {
                valid['enVisionWSURL'] = false;
            } else {
                valid['enVisionWSURL'] = true;
            }

            // if (!("webServiceToken" in companyInfo) || companyInfo.webServiceToken.length === 0) {
            //     valid['webServiceToken'] = false;
            // } else {
            //     valid['webServiceToken'] = true;
            // }

            if (!("enVisionChunkerTempPath" in companyInfo) || companyInfo.enVisionChunkerTempPath.length === 0) {
                valid['enVisionChunkerTempPath'] = false;
            } else {
                valid['enVisionChunkerTempPath'] = true;
            }

            if (!("enVisionIntegrationUserId" in companyInfo) || companyInfo.enVisionIntegrationUserId.length === 0 || companyInfo.enVisionIntegrationUserId === 0) {
                valid['enVisionIntegrationUserId'] = false;
            } else {
                valid['enVisionIntegrationUserId'] = true;
            }

            if (!("defaultDocumentType" in companyInfo) || companyInfo.defaultDocumentType.length === 0) {
                valid['defaultDocumentType'] = false;
            } else {
                valid['defaultDocumentType'] = true;
            }

            if (!("encryptedUserName" in companyInfo) || companyInfo.encryptedUserName.length === 0) {
                valid['encryptedUserName'] = false;
            } else {
                valid['encryptedUserName'] = true;
            }

            if (!("encryptedUserPassword" in companyInfo) || companyInfo.encryptedUserPassword.length === 0) {
                valid['encryptedUserPassword'] = false;
            } else {
                valid['encryptedUserPassword'] = true;
            }

            if (!("useChunkerPath" in companyInfo) || companyInfo.useChunkerPath.length === 0) {
                valid['useChunkerPath'] = false;
            } else {
                valid['useChunkerPath'] = true;
            }
        }

        // console.log(valid)
        setValid(valid)
        let isValid = Object.values(valid).find((val) => val === false)
        // console.log(isValid)
        return isValid

    }

    const updateEnVisionCompanyData = (data) => {
        let error = checkValidation();
        if (typeof error === 'boolean') return;
        const url = `/api/companies/${data.companyId}/evCompany`;

        const companyObj = {
            "companyId": companyInfo.companyId,
            "companyName": companyInfo.companyName,
            "enVisionWSURL": companyInfo.enVisionWSURL || data.enVisionServerUrl,
            "webServiceToken": data.webServiceToken,
            "enVisionChunkerTempPath": companyInfo.enVisionChunkerTempPath,
            "enVisionIntegrationUserId": +companyInfo.enVisionIntegrationUserId,
            "defaultDocumentType": companyInfo.defaultDocumentType,
            "encryptedUserName": companyInfo.encryptedUserName,
            "encryptedUserPassword": companyInfo.encryptedUserPassword,
            "useChunkerPath": companyInfo?.useChunkerPath?.toLowerCase() === 'true' ? true : false
        }

        axios({
            method: "put",
            url: url,
            data: companyObj,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        }).then((data) => {
            handleClose()

            let message = `Company updated successfully.`;

            setNotify({
                isOpen: true,
                alertTitle: 'Success',
                message: message,
                severity: 'success'
            });

            //reloading the table
            setReload(true)
        }).catch((error) => {
            console.log('error in update profile api call:', error);

            let message = `Failed to update envision company [${data.companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

            setNotify({
                isOpen: true,
                alertTitle: 'Update envision company failed',
                message: message,
                severity: 'error'
            });
        })
    }

    const createEnVisionCompany = (data) => {
        let error = checkValidation();
        if (typeof error === 'boolean') return;

        let enVisionUrl = `/api/companies/${data.companyId}/evCompany`;
        axios({
            method: "post", url: enVisionUrl,
            // data: data,
            data: { ...companyInfo, "enVisionIntegrationUserId": +companyInfo.enVisionIntegrationUserId, "useChunkerPath": companyInfo.useChunkerPath?.toLowerCase() === 'true' ? true : false },
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                handleClose()

                let message = `enVision Company created successfully.`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Success',
                    message: message,
                    severity: 'success'
                });

                //reloading the table
                setReload(true)
            }).catch(error => {
                console.log('error in creating envision company api call:', error);
                let message = `Failed to create enVision company [${data.companyId}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;


                setNotify({
                    isOpen: true,
                    alertTitle: 'Envision company creation failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const handleEnVisionAction = () => {
        if (action === 'create') {
            data = {
                'companyId': data.companyId,
                'companyName': data.name,
            };
            createEnVisionCompany(data);
        }

        if (action === 'edit') {
            updateEnVisionCompanyData(companyInfo);
        }
    };

    const initialSnackbarState = {
        open: false,
        message: '',
        alertTitle: '',
        severity: 'info',
        hideDuration: 1000
    };

    const [notify, setNotify] = useState(
        initialSnackbarState
    );


    const handleChange = (e, field) => {
        setCompanyInfo({ ...companyInfo, [field]: e?.target?.value })
    }

    return (
        <>
            <AlertSnackbar
                notify={notify}
                setNotify={setNotify} />

            <Dialog onClose={handleClose} open={open} maxWidth={'sm'} fullWidth={true}>
                <DialogTitle>
                    <div className="userPermissionDialogTitle">enVision Company Information</div>
                    {onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField disabled={true} size="small" required label="Company Id" variant="outlined" value={data?.companyId} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required error={('companyName' in valid) && !valid.companyName} helperText={('companyName' in valid) && !valid.companyName ? "Company Name is required" : ""} label="Company Name" variant="outlined" onChange={(e) => handleChange(e, 'companyName')} value={companyInfo?.companyName} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("enVisionWSURL" in valid) && !valid.enVisionWSURL} helperText={("enVisionWSURL" in valid) && !valid.enVisionWSURL ? "enVision URL is required" : ""} label="enVision URL" variant="outlined" onChange={(e) => handleChange(e, 'enVisionWSURL')} value={companyInfo?.enVisionWSURL} fullWidth />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required label="WebService Token" variant="outlined" onChange={(e) => handleChange(e, 'webServiceToken')} value={companyInfo?.webServiceToken} fullWidth />

                            <FormControl variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={(e) => handleChange(e, 'webServiceToken')} value={companyInfo?.webServiceToken}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                            </FormControl>
                        </Grid> */}

                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("encryptedUserName" in valid) && !valid.encryptedUserName} helperText={("encryptedUserName" in valid) && !valid.encryptedUserName ? "encrypted User Name is required" : ""} label="encrypted User Name" variant="outlined" onChange={(e) => handleChange(e, 'encryptedUserName')} value={companyInfo?.encryptedUserName} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            {/* <TextField disabled={isReadOnly} size="small" required label="encrypted User Password" variant="outlined" onChange={(e) => handleChange(e, 'encryptedUserPassword')} value={companyInfo?.encryptedUserPassword} fullWidth /> */}
                            <FormControl error={("encryptedUserPassword" in valid) && !valid.encryptedUserPassword} fullWidth variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    required={action !== 'create' ? true : false}
                                    type={showPassword ? 'text' : 'password'}
                                    disabled={isReadOnly}
                                    size="small"
                                    onChange={(e) => handleChange(e, 'encryptedUserPassword')} value={companyInfo?.encryptedUserPassword}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                disabled={isReadOnly}
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Password"
                                />
                                <FormHelperText>
                                    {("encryptedUserPassword" in valid) && !valid.encryptedUserPassword ? "Password is required" : ""}
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("enVisionChunkerTempPath" in valid) && !valid.enVisionChunkerTempPath} helperText={("enVisionChunkerTempPath" in valid) && !valid.enVisionChunkerTempPath ? "enVisionChunker Temp Path is required" : ""} label="enVisionChunker Temp Path" variant="outlined" onChange={(e) => handleChange(e, 'enVisionChunkerTempPath')} value={companyInfo?.enVisionChunkerTempPath} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("enVisionIntegrationUserId" in valid) && !valid.enVisionIntegrationUserId} helperText={("enVisionIntegrationUserId" in valid) && !valid.enVisionIntegrationUserId ? "enVision Integration UserId is required" : ""} label="enVision Integration UserId" variant="outlined" onChange={(e) => handleChange(e, 'enVisionIntegrationUserId')} value={companyInfo?.enVisionIntegrationUserId} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("defaultDocumentType" in valid) && !valid.defaultDocumentType} helperText={("defaultDocumentType" in valid) && !valid.defaultDocumentType ? "default DocumentType is required" : ""} label="default DocumentType" variant="outlined" onChange={(e) => handleChange(e, 'defaultDocumentType')} value={companyInfo?.defaultDocumentType} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled={isReadOnly} size="small" required={action !== 'create' ? true : false} error={("useChunkerPath" in valid) && !valid.useChunkerPath} helperText={("useChunkerPath" in valid) && !valid.useChunkerPath ? "use ChunkerPath is required" : ""} label="use ChunkerPath" variant="outlined" onChange={(e) => handleChange(e, 'useChunkerPath')} value={companyInfo?.useChunkerPath} fullWidth />
                        </Grid>
                        {action !== 'create' ?
                            <>
                                <Grid item xs={12}>
                                    <TextField disabled={true} size="small" label="Last Content Updated Date" variant="outlined" value={data?.lastContentUpdatedDate} fullWidth />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField disabled={true} size="small" label="last ContentUpdated UserId" variant="outlined" value={data?.lastContentUpdatedUserId} fullWidth />
                                </Grid>
                            </> : <></>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {action !== 'view' ?
                        (
                            <>
                                <Button variant="text" size="small" sx={{ textTransform: 'none' }} onClick={handleClose}>Cancel</Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        color: '#333330',
                                        backgroundColor: '#82C027',
                                        boxShadow: '0px 1px 2px #6F7687',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                        '&:hover': {
                                            backgroundColor: '#82C027',
                                            boxShadow: 'none'
                                        }
                                    }}
                                    onClick={handleEnVisionAction}>Save</Button></>) : ""}
                </DialogActions>

            </Dialog >
        </>

    );
};

export default CompanyEnvisionDialog;
